
import { defineComponent } from "@vue/runtime-core";
import { computed, ComputedRef, PropType } from "vue";
import {
  CourseCertificate,
  EnrolledTraining
} from "../../../../domain/entities/entities";
import { formatTime } from "../../views/exercise/exercise_helpers";
import { wrapLoading } from "../../utils/wrap_loading";
import { dispatchError } from "../../utils/error_handling";
import { useStore } from "vuex";
import { formattedDuration } from "../mixins";

export default defineComponent({
  name: "LineOnlineTraining",
  props: {
    training: {
      type: Object as PropType<EnrolledTraining>,
      required: true
    }
  },
  setup() {
    const store = useStore();

    const certificate: ComputedRef<CourseCertificate> = computed(
      () => store.getters["course_module/certificate"]
    );

    /** Loads a certificate and opens a new browser tab with the certificate's PDF.
     * @param courseID ID of the certificate's course
     */
    const openCertificate = async (courseID: number): Promise<void> => {
      try {
        await wrapLoading(async () => {
          await store.dispatch("course_module/loadCertificate", courseID);
        }, "Gerando certificado...");

        window.open(certificate.value.path, "_blank");
      } catch (e) {
        await dispatchError(e);
      }
    };

    /** Checks if the course is active or not. */
    const isInactive = (training: EnrolledTraining): boolean => {
      const currentDate = new Date().toISOString().split("T")[0];

      if (!training.isActive) {
        return true;
      }

      return (
        currentDate < training.activationDate ||
        currentDate > training.inactivationDate
      );
    };

    return {
      formatTime,
      openCertificate,
      isInactive,
      formattedDuration
    };
  }
});
